import type { ChartData, ChartOptions } from "chart.js";
import { min } from "mathjs";
import { createBlackoutPattern } from '../blackoutPattern';

export function reserveChartOption(): ChartOptions {
  return {
    animation: false,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: 'System Reserve',
        color: 'rgba(255,255,255,0.88)',
        font: { size: 12 },
        padding: { bottom: 4 },
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          offset: false,
          color: 'rgba(255,255,255,0.08)',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Reserve (%)',
          padding: -2,
          font: { size: 11 },
          color: 'rgba(255,255,255,0.65)',
        },
        max: 30,
        min: -20,
        grid: { color: 'rgba(255,255,255,0.08)' },
      },
    },
  };
}

interface IReserveChartData {
  reservesAvali: any;
  dataIndex: any;
  optionsData: any;
  annualConst: any;
  reserveRemaining: any;
}

export function reserveChartData({
  reservesAvali,
  dataIndex,
  optionsData,
  annualConst,
  reserveRemaining,
}: IReserveChartData): ChartData {
  let systemColor: string | CanvasPattern;
  let minReserveAvalible = min(reservesAvali);
  if (
    minReserveAvalible < 0 ||
    annualConst.annualTechGen[dataIndex.blackout] > 0
  ) {
    systemColor = createBlackoutPattern();
  } else if (minReserveAvalible <= optionsData.minReserve) {
    systemColor = "orange";
  } else {
    systemColor = "green";
  }

  return {
    labels: ["Reserve"],
    datasets: [
      {
        label: 'My Reserve',
        borderWidth: 1,
        borderRadius: 4,
        borderColor: typeof systemColor === 'string' ? systemColor : 'rgba(160,20,20,0.85)',
        backgroundColor: systemColor,
        data: [reserveRemaining],
      },
    ],
  };
}
